import { useState } from "react";
import xIcon from "../../../../../assets/img/x-icon.svg";

const InputSubTimes = ({ title, subTagsId, removeTag, index }) => {
  const [inputOpened, setInputOpened] = useState(false);

  return (
    <>
      <div className={`bg-cl-lightgray  px-3 p-1 m-2 rounded-1 tag${subTagsId}`}>
        <div className="d-flex border-0 c-pointer align-items-center ">
          <span className="text-nowrap fz-16">{title}</span>
          <img alt="delete variation" className="ms-2" src={xIcon} onClick={() => removeTag(subTagsId, index)} />
        </div>
      </div>
    </>
  );
};

export default InputSubTimes;
